module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note10 Aura Glow.07d95712.png";